import type { CurrencySymbolsVO } from '@/types';
import { gatewayRequest } from '@/utils/http';

/** 启动时取正式符号表；契约缺失必须阻止依赖符号的语言包初始化。 */
export async function listCurrencySymbols(): Promise<CurrencySymbolsVO> {
  const value = await gatewayRequest<unknown>(
    '/site/gateway/currency/listCurrencySymbols',
    {
      method: 'GET',
      skipAuth: true,
      skipErrorHandler: true,
    },
  );
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    throw new Error('Invalid currency symbol response');
  }
  const entries = Object.entries(value);
  if (
    !entries.length ||
    entries.some(
      ([currency, symbol]) =>
        !/^[A-Z]{3}$/.test(currency) ||
        typeof symbol !== 'string' ||
        !symbol.trim(),
    ) ||
    !Object.hasOwn(value, 'HKD')
  ) {
    throw new Error('Invalid currency symbol response');
  }
  return value as CurrencySymbolsVO;
}
